import { call, put, takeLatest } from 'redux-saga/effects'
import { setSubscriptionStatus } from 'actions/inventory/ingredientSubscription'
import { getSubscriptionStatus } from 'api/feature/getSubscriptionStatus'
import { INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS } from 'actions/inventory/ingredientSubscription/constant'
import {INGREDIENT_FEATURE} from 'actions/inventory/constants'

export function * getSubscriptionStatusFlow () {
  const response = yield call(getSubscriptionStatus, {feature_names: [INGREDIENT_FEATURE]})
  yield put(setSubscriptionStatus(response.data[0]))
}

export default function * saga () {
  yield takeLatest(INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS, getSubscriptionStatusFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/inventory/ingredientSubscription.js